export default __webpack_public_path__ + "1068fa373e8c7c53d5e8905407a8998b.png";